export const en = {
  addIntegration: 'Add an integration',
  firstIntegration: 'Click here to set up your first integration.'
};

export type Translations = typeof en;
